import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'customer-stats',
  name: '客户统计',
  icon: '客',
  group: 'CRM 组件',
  description: '展示客户总数、跟进中和已成交等指标。',
  defaultProps: {
    title: '客户概览'
}
}
